<template>
	<div class="container">
		<video controls :src="detailmodel.video">
			您的浏览器不支持 video 标签。
		</video>
	</div>
</template>

<script>
	import competitionModules from '@/modules/competition.js'
	export default {
		name: 'competitionVideo',
		components: {
			
		},
		mixins: [
			competitionModules
		],
		data(){
			return {
				
			}
		},
		methods: {
			
		}
	}
</script>

<style lang="less" scoped>
	.container{
		video{
			width: 100%;
		}
	}
</style>
